import * as React from 'react';
import CompaniesIndex from '../../components/Companies/mine';
import * as CompaniesApi from '../../api/companies';

export default class CompaniesIndexContainer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      companies: [],
      pages: 0,
      page: 1,
      isLoading: true,
    };

    this.onPageChange = this.onPageChange.bind(this);
  }

  async onPageChange({ page }) {
    const { data, headers } = await CompaniesApi.list({
      limit: 10,
      offset: (page - 1) * 10,
    });

    const pages = parseInt(headers['x-total-count'], 10);

    this.setState({
      companies: data,
      pages,
      page,
    });
  }

  async componentDidMount() {
    this.onPageChange({ page: 1 });
  }

  render() {
    return (
      <CompaniesIndex
        companies={this.state.companies}
        pages={this.state.pages}
        page={this.state.page}
        onPageChange={this.onPageChange}
      />
    );
  }
}
